
import React, { useEffect, useState } from "react";
import { Accordion, AccordionSummary, Typography, Box, Card, Grid, Button, Pagination, CircularProgress, Paper } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import PartnerPreferencesForm from "../Authentication/PartnerPrefrencesForm";
import { matrimoneyEndPoints } from "../../../services/apis";
import axios from "axios";
import CustomPagination from "./pagination";
import FollowUpModal from "./customerFollows";
import { showError, showSuccess } from "./sweetAlert/sweetAlert";
import { commonSubmitData } from "../../../services/operations/userOperations";


const CustomerFollows = (props) => {
  // const [partnerData, setProfileData] = useState(props?.partnerData)
  const [expanded, setExpanded] = useState(null);
  const [open, setOpen] = useState(false)
  let getMyProfileData = localStorage.getItem("profileData")
  let MyProfileData = JSON.parse(getMyProfileData)
  let userType = sessionStorage.getItem("userType")
  const customerId = sessionStorage.getItem("customerId")
  const loginUserToken = sessionStorage.getItem("loginUserToken")
  const [partnerMatchedData, setPartnerMatchedData] = useState({})
  const getCustomerData = async () => {
    try {
      let userType = sessionStorage.getItem("userType")
      let token
      if (userType) {
        token = sessionStorage.getItem("token");
      } else {
        token = localStorage.getItem("token");
      }
      const response = await axios.post(
        matrimoneyEndPoints.VIEW_CUSTOMER_DETAILS,
        { profileId: props?.profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        // setProfileData(response?.data?.data["Partner Details"])
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };
  const [spinner, setSpinner] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const itemsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [followUpData, setFollowupData] = useState([])
  const getCustomerFollowupsData = async (url, payload, token) => {
    const response = await commonSubmitData(url, payload, token);
    if (response.status) {
      setFollowupData(response.data)
      setTotalCount(response.totalCount)
    } else {
      setTotalCount(0)
      setFollowupData([])
    }
  }
  const handlePageChange = async (page) => {
    await getCustomerFollowupsData(matrimoneyEndPoints.CUSTOMER_FOLLOWUP_DATA, { skip: (page - 1) * 10, limit: page * 10, "customerId": Number(customerId) }, loginUserToken)
    setCurrentPage(page);
  };


  const handleSave = async (data) => {
    let payload = {
      "customerId": customerId ? Number(customerId) : null,
      "comments": data?.comments,
      "followUpDate": data?.followUpDate ? data?.followUpDate : null
    }

    const response = await commonSubmitData(matrimoneyEndPoints.ADD_CUSTOMER_FOLLOWUP_DATA, payload, loginUserToken);

    if (!response.status) {
      showError(response?.message)
      return false;
    } else {

      showSuccess(response?.message)
      return true
    }

  };
  useEffect(() => {
    if (!open) {
      getCustomerData()
      getCustomerFollowupsData(matrimoneyEndPoints.CUSTOMER_FOLLOWUP_DATA, { "skip": 0, "limit": 10, "customerId": Number(customerId) }, loginUserToken)
    }
  }, [open])
  // if (!partnerData) {
  //     return <p>No profile data available.</p>;
  // }
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: "flex-end",
          marginBottom: "10px"
          // alignItems: 'center',
          // padding: '10px',
        }}
      >
        {/* <Typography
                    sx={{
                        fontFamily: '"Roboto Condensed", sans-serif',
                        fontWeight: 600,
                        fontSize: '24px',
                        // lineHeight: '100%',
                        letterSpacing: '0%',
                    }}
                >
                    Partner Details
                </Typography> */}

        {((MyProfileData && MyProfileData.id == props?.profileId) || userType) && <Button
          variant="contained"
          // onClick={()=>navigate("/profile/education", { state: { type: "edit" } })}
          onClick={() => (setOpen(!open), setShowModal(!open))}


          sx={{
            backgroundColor: '#C1721F',
            color: 'white',
            display: 'flex',
            alignItems: 'right',
            gap: '5px',
          }}
        >
          {open ? "View" : "Add"}
        </Button>}
      </Box>

      {!open ? <Card
        sx={{
          ...styles.card,
          height: { xs: "auto", sm: 'auto' },
          width: "100%",
          padding: { xs: 2, sm: 4 },
          borderRadius: "5px"
        }}
      >
        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />

        <Box sx={{
          width: "100%",
          margin: "auto",
          backgroundColor: "white",
          border: "2px solid #C1721F",
          padding: { xs: "10px", sm: "50px 50px" },
          borderRadius: "10px",
          boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
        }}>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                mb: 2,
                marginTop: { xs: "auto", md: "-5%" }
              }}
            >
              <Box display="inline-flex">
                <CustomPagination
                  totalItems={totalCount}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </Box>
            </Grid>

            {spinner ? (
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                <CircularProgress color="primary" size={60} />
              </Grid>
            ) : followUpData.length > 0 ? (
              followUpData.map((each, index) => (
                // <Paper
                //   key={each.id}
                //   elevation={3}
                //   sx={{
                //     p: 1,
                //     my: 1,
                //     borderRadius: 2,
                //     backgroundColor: "#f9f9f9",
                //     borderLeft: "5px solid #1976d2",
                //   }}
                // >
                <Grid 
                  item xs={12} key={each.id}
                  elevation={3}
                  sx={{
                    p: 1,
                    my: 1,
                    borderRadius: 2,
                    backgroundColor: "#f9f9f9",
                    borderLeft: "5px solid #1976d2",
                  }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={2}>
                      <Typography variant="subtitle2" color="text.secondary">S.No</Typography>
                      <Typography variant="body1">{(currentPage - 1) * itemsPerPage + index + 1}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <Typography variant="subtitle2" color="text.secondary">Date</Typography>
                      <Typography variant="body1">{each.createdAtRead}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <Typography variant="subtitle2" color="text.secondary">Employee ID</Typography>
                      <Typography variant="body1">{each.staff?.id}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <Typography variant="subtitle2" color="text.secondary">Comments</Typography>
                      <Typography variant="body1">{each.comments}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <Typography variant="subtitle2" color="text.secondary">Follow-Up Date</Typography>
                      <Typography variant="body1">{each.followUpDateRead}</Typography>
                    </Grid>
                  </Grid>
                {/* </Paper> */}
                </Grid>
              ))
            ) : (
              <Grid item xs={12} sx={{ textAlign: 'center', mt: 4 }}>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
                  alt="No Data Found"
                  style={{ marginBottom: 16, maxWidth: '100px', opacity: 0.6 }}
                />
                <Typography variant="h6" color="text.secondary">
                  No Profiles Found
                </Typography>
              </Grid>
            )}

          </Grid>
          {/* <Card sx={{ padding: "10px 50px", mb: "0px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", border: "3px solid rgba(0, 0, 0, 0.1)" }}>
                        <Typography sx={{ ...styles.viewtextstyle }}>
                            Partner Details
                        </Typography>
                        <Grid container spacing={2} >
                            
                        </Grid>
                    </Card> */}
        </Box>
      </Card> :
        <>
          <Box sx={{ width: { xs: "auto", sm: "800px", md: "1405px" }, margin: "auto" }}>
            <FollowUpModal
              show={showModal}
              handleClose={() => setShowModal(false)}
              onSave={handleSave}
            />
          </Box>
        </>
      }

      {/* </Accordion> */}
    </Box>
  );
};

export default CustomerFollows;
